import {lazy} from 'react';


export const DeviceOperationalStatisticByDevicesLazy = lazy(() => import('./DeviceOperationalStatisticByDevices'))